import { SWS_HOST } from '@/constants';
import { ValuationTranslation } from '@/pages/CompanyReport/components/Valuation/hooks/useValuationTranslation';
import { Button } from '@simplywallst/ui-core';

const PeersHelpContent = () => {
  return (
    <div>
      <ValuationTranslation i18nKey="vsPeers.help.description">
        <p>
          Peers are the companies that are most similar to the company we are
          valuing. Arriving at a relevant list of peers includes things like
          what products they make or services they provide, but also things like
          their size, growth rates and structure of their income statement and
          balance sheets.
        </p>
        <p>
          Selecting a group of peers is a difficult task, requiring years of
          experience. Our peers algorithm gives you the power of that experience
          by selecting peers, using a range of data points.
        </p>
        <p>
          For a more detailed breakdown of how we select relevant peers, please
          check out our
          <Button
            as="a"
            target="_blank"
            href={`${SWS_HOST}/help/articles/hc/en-us/articles/4751563581071-Understanding-the-Valuation-section-in-the-company-report?section=Comparison-to-Peers`}
            rel="noopener noreferrer"
            styleType="strongLink"
          >
            Help Centre.
          </Button>
        </p>
      </ValuationTranslation>
    </div>
  );
};
export default PeersHelpContent;
